/**
 * Labstep
 */

import { fieldSignatureRequirementStatement } from 'labstep-web/components/SignatureRequirement/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import { Pre } from 'labstep-web/core/Pre';
import type React from 'react';
import type { ISignatureRequirementFormShowEditStatementProps } from './types';

export const SignatureRequirementFormShowEditStatement: React.FC<
  ISignatureRequirementFormShowEditStatementProps
> = ({ signatureRequirement }) => (
  <ShowEditText
    entityName={signatureRequirement.entityName}
    entity={signatureRequirement}
    field={fieldSignatureRequirementStatement}
    placeholder="Add default statement"
  >
    <Pre>{signatureRequirement.statement}</Pre>
  </ShowEditText>
);
